import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../actions/auth';
import { makeStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem
} from '@material-ui/core';

const Navbar = ({ auth: { isAuthenticated, loading }, logout, history }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      flexGrow: 1
    },
    menuButton: {
      marginRight: theme.spacing(2)
    },
    title: {
      flexGrow: 1.25,
      paddingLeft: '2.5%'
    },
    link: {
      color: '#fff'
    }
  }));

  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const authLinks = (
  //   <Button color='inherit' onClick={logout}>
  //     Logout
  //   </Button>
  // );

  return (
    <Fragment>
      {isAuthenticated && (
        <div className={classes.root} style={{ marginBottom: '80px' }}>
          <AppBar position='fixed'>
            <Toolbar>
              <Typography variant='h6' className={classes.title}>
                <Link to='/actions' className={classes.link}>
                  Autopilot CRM
                </Link>
              </Typography>
              <Typography variant='h6' className={classes.root}>
                <Link to='/actions' className={classes.link}>
                  Action Streams
                </Link>
              </Typography>
              <Typography variant='h6' className={classes.root}>
                <Link to='/contacts' className={classes.link}>
                  Contacts
                </Link>
              </Typography>
              <Typography variant='h6' className={classes.root}>
                <Link to='/activities' className={classes.link}>
                  Activity
                </Link>
              </Typography>
              <Typography variant='h6' className={classes.root}>
                <i
                  className='fas fa-user-circle'
                  aria-controls='simple-menu'
                  aria-haspopup='true'
                  onClick={handleClick}
                ></i>{' '}
                <Menu
                  id='simple-menu'
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleClose}>
                    <Link to='/addContact'>Add Contact</Link>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Link to='/activities'>All Activities</Link>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Link onClick={logout} to='/'>
                      Logout
                    </Link>
                  </MenuItem>
                </Menu>
              </Typography>
            </Toolbar>
          </AppBar>
        </div>
      )}
    </Fragment>
  );
};

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps, { logout })(Navbar);



// WEBPACK FOOTER //
// ./src/components/Layout/Navbar.js